
import { Dialog, DialogTitle, DialogActions, DialogContentText, TextField, Radio, Button, DialogContent, ListItemText, Typography, Divider, Table, TableHead, TableRow, TableCell, TableBody } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import CancelIcon from '@mui/icons-material/CancelOutlined';
import Save from '@mui/icons-material/Save';
import Box from "@material-ui/core/Box";
import { makeStyles } from '@material-ui/core/styles';
import { useTranslation } from 'react-i18next';
import { uploadSweepSamplePictureFile } from '../../services/FileService';
import ImgsViewer from "react-images-viewer";
import { uploadPreformDrawingFile, getSavedFile } from '../../services/FileService';



function SweepSetSampleInfoDialog(props) {
    const { openDialog, onDialogClose,onDialogClose2, sweepSetSampleInfoList, sample, descriptors } = props
    const [alertBox, setAlertBox] = useState("");
    const [newSweepSetSampleInfoList, setNewSweepSetSampleInfoList] = useState([]);
	const [newDescriptors, setNewDescriptors] = useState([]);
    
    const [viewImage, setViewImage] = useState(false);
    const [imageSrc, setImageSrc] = useState(''); //for thumbnail if required
    const [imageForViewer, setImageForViewer] = useState([]);

    const [saving, setSaving] = useState(false);


    const { t } = useTranslation();

    
    const useStyles = makeStyles((theme) => ({
        root: {
            flex: 1,
            backgroundColor: 'paper',
        },
        dialog: {
            width: '400px',
            display: 'flex'
        },
        dialogBox: {
            display: 'flex',
            alignItems: 'center'
        },
        dialogText: {
            flex: '0.4'
        },
        dialogInput: {
            flex: '0.5'
        },
        formControl: {
            margin: theme.spacing(2),
            minWidth: 120,
            maxWidth: 300,
        },
        chips: {
            display: 'flex',
            flexWrap: 'wrap',
        },
        chip: {
            margin: 2,
        },
        noLabel: {
            marginTop: theme.spacing(2),
        },
        noWrapCell: {
            whiteSpace: 'nowrap'
        }
    }));

    const handleClose = () => {
        onDialogClose(null);
    };

    const handleSave = () => {
		console.log("HANDLE SAVE");
        onDialogClose2(descriptors);
    };

    const classes = useStyles();

    useEffect(() => {
        const copyList = [...sweepSetSampleInfoList]

        setNewSweepSetSampleInfoList(copyList);

    }, [sweepSetSampleInfoList]);

	useEffect(() => {
		console.log("USE EFFECT descriptors",descriptors);
		const copyList = [...descriptors]

		// getSampleImages().then((res) => {
		//     setNewSweepSetSampleInfoList(res);
		// });
		setNewDescriptors(copyList);
		console.log("USE EFFECT newDescriptors",newDescriptors, copyList);
	
	}, [descriptors]);
	
	
	useEffect(() => {
		console.log("SAMPLE",sample);

	}, [sample]);

    const getSampleImages = async () => {
        let copyList = [...sweepSetSampleInfoList];
        // copyList.forEach((item) => {
        // let copyList = sweepSetSampleInfoList.map((item) => {
        for (let i = 0; i < copyList.length; i++) {

        
            if (copyList[i].picturePath) {
                
                    getSavedFile(copyList[i].picturePath).then((data) => {
                        if (data) {
                            let image = `data:image/jpeg;base64,${data}`;
                            // setImageSrc(image); //for thumbnail if required
                            copyList[i].imageSrc = image;
                            
                            /**
                             * for ImgsViewer
                             */
                            let imageArray = [];
                            let imageForViewer = { src: image };
                            imageArray.push(imageForViewer);
                            // item.imageArray = imageArray;
                            // item.imageName = item.picturePath;
                            
                            // setImageForViewer(imageArray);

                            // return {...item, imageArray: imageArray};
                            copyList[i].imageArray = imageArray;
                            copyList[i].imageName = copyList[i].picturePath;
                        }

                    });
                    
                
            }
        };

        return copyList;
    }
    
	const handleDescriptorChange = (event, index) => {        
		let newList = descriptors.map((descr, i) => {
	    if (i === index) {
			descr.value=event.target.value;
			return descr;
	    }
	    else {
	        return descr;
	    }
	});

	setNewDescriptors(newList);
	}

	


	
    const handleUpcTextChange = (event, index) => {        
        let newList = newSweepSetSampleInfoList.map((sample, i) => {
            if (i === index) {
                return {...sample, upcText: event.target.value}
            }
            else {
                return sample;
            }
        });

        setNewSweepSetSampleInfoList(newList);
    }

	
	

    const handlepreformDrawingNameClick = (event) => {
        setViewImage(true);
    }

    const handlePreformDrawingChange = (event) => {
        // setPreformDrawing(event.target.files[0]);
        // setPreformDrawingName(event.target.files[0].name);
        // setIsPreformDrawingPicked(true);
        setSaving(true);
        let types = ['image/png', 'image/jpg', 'image/jpeg', 'image/gif'];
        // if (isPreformDrawingPicked) {
        let preformDrawing = event.target.files[0];
        let preformDrawingName = event.target.files[0].name
		console.log("SAVING IMAGE FOR SAMPLE ",sample,preformDrawingName);
        if (types.indexOf(preformDrawing.type.toLowerCase()) > -1) {
            const uploadPreformDrawing = async () => {
                try {
                    await uploadSweepSamplePictureFile(preformDrawing, sample.id).then((res,err) => {
                        console.log(res)
                        if (res.key) {
                            // setPreformDrawingPath(res.key);
                            setPictureChange(res.key);

                        } 
                        setSaving(false);
                    });
                }
                catch (err) {
                    setSaving(false);
                    console.err(err)
                }
            }
            uploadPreformDrawing();
        }
        else {
            alert(t("image_type_error"));
            setSaving(false);
        }
            
        // }
    };
	const setPictureChange = (picturePath) => 
	{
		sample.picturePath=picturePath;
		console.log("PICTURE CHANGE ",picturePath);
	    return sample;
	}

    const handleImageClose = (event) => {
        setViewImage(false);
    }

    const onBrowseClick = (event) => {
        event.target.value = null;
    };

    const getPictureName = (path) => {
        // let x = path.split("/").pop()
        let filename = path.split('\\').pop().split('/').pop()
        return filename;
    }


    return (

        <div>
            <Dialog open={openDialog} aria-labelledby="form-dialog-title" fullWidth maxWidth="xl" minHeight="xl" scroll='paper'>
                <DialogTitle id="alert-dialog-title">Parameters for Sweep Set Sample </DialogTitle>
                {/* NOTE: selectedRow && -> checks if selectedRow is defined before rendering the data */}
                {/* {sweepSetSampleInfoList && ( */}
                    <DialogContent>
                        {alertBox}
						<Table> 
						<TableBody>
						<TableRow>
						    <TableCell><strong>ID</strong></TableCell>
							<TableCell>{sample.uniqueId}</TableCell>
						</TableRow>
							<TableRow>
							<TableCell><strong>Picture</strong></TableCell>
							<TableCell>


<div className={classes.dialogBox} style={{ display: 'flex', flexDirection:"column" }}>
	{sample.picturePath && <label>{getPictureName(sample.picturePath)}</label>}
<div className={classes.dialogBox} style={{ display: 'flex', flex: '20%', justifyContent:"center" }}>
	<Button variant="contained" component="label" style={{ flex: '100%', maxWidth: '50%'}}>{t("browse_label")}
	<input type="file" accept="image/*" hidden className={classes.dialogText} onChange={(e) => handlePreformDrawingChange(e)} onClick={onBrowseClick} id="preformDrawingName" />
	</Button>
</div>
</div>
</TableCell>
</TableRow>

						    {newDescriptors.length > 0 &&
						        newDescriptors.map((descriptor, index) => (
						            <TableRow>
						                <TableCell>
						                    <strong>{descriptor.sweepDescriptor.name}</strong>
						                </TableCell>
						                <TableCell>
						                    <TextField value={descriptor.value? descriptor.value: ""} 
											onChange={(e) => handleDescriptorChange(e, index)} className={classes.dialogInput} 
											margin="dense" id="name" type="input" variant="outlined" required />
						                </TableCell>
									</TableRow>
									))}
	
						</TableBody>
						</Table> 
						
						
                            
                    </DialogContent>
                {/* )} */}
                <DialogActions>
                    <Tooltip title="Save">
                        <IconButton disabled={saving} onClick={handleSave}>
                            <Save />
                        </IconButton>
                    </Tooltip>
                    <Tooltip title="Close">
                        <IconButton onClick={handleClose}>
                            <CancelIcon />
                        </IconButton>
                    </Tooltip>
                </DialogActions>
            </Dialog>
        </div>
    );
}


export default SweepSetSampleInfoDialog
